<template>
  <div>
    <v-dialog
      width="500"
      v-model="dialog"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" elevation="0" variant="tonal">
          <v-icon size="small" class="mr-2">mdi-account-plus</v-icon>
          <span style="font-size: 12px">Invite users</span>
        </v-btn>
      </template>

      <v-card
        flat
        width="500"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div class="pa-6">
          <h2 class="mb-4">Invite users</h2>
          <div
            class="email mb-2"
            v-for="(invite, index) in invites"
            :key="index"
          >
            <v-text-field
              placeholder="name@company.com"
              v-model="invite.email"
              hide-details=""
              variant="solo"
              style="border-radius: 6px"
              flat
              bg-color="smoke"
              @keyup.enter="sendInvite()"
            ></v-text-field>
            <v-select
              label="Role"
              style="border-radius: 6px"
              variant="solo"
              flat
              item-props
              hide-details=""
              bg-color="smoke"
              :items="filteredRoles"
              v-model="invite.role"
            >
              <template v-slot:item="{ props }">
                <v-list-item v-bind="props" :title="capitalize(props.title)">
                </v-list-item>
              </template>
            </v-select>
          </div>
          <div class="d-flex justify-space-between mt-6">
            <v-btn elevation="0" @click="addInvite"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
            <div class="d-flex" style="gap: 10px">
              <v-btn
                elevation="0"
                text
                class="px-6"
                @click="
                  sent = false;
                  dialog = false;
                "
                >Close</v-btn
              >
              <v-btn
                :disabled="disabled"
                elevation="0"
                class="px-6"
                color="button"
                :loading="sendingInvites"
                @click="sendInvite()"
                >Send</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      workspace: (state) => state.workspace.workspace,
    }),
    filteredRoles() {
      let user_role = this.$store.state.workspace.workspace.members.find(
        (m) => m.uid === this.$store.state.users.userProfile.uid
      ).role;
      console.log(user_role);
      if (user_role === "editor") {
        return ["editor"];
      } else {
        return ["editor", "admin"];
      }
    },
    disabled() {
      let disabled = false;

      this.invites.map((i) => {
        if (!i.email || !i.role) {
          disabled = true;
        }
      });

      return disabled;
    },
  },
  data() {
    return {
      dialog: false,
      invites: [
        {
          email: "",
          role: "admin",
          invited: true,
          status: null,
        },
      ],
      roles: ["admin", "editor"],
      sendingInvites: false,
      sent: false,
    };
  },
  methods: {
    addInvite() {
      this.invites.push({
        email: "",
      });
    },
    capitalize(string) {
      let firstCharacter = string.charAt(0);
      firstCharacter = firstCharacter.toUpperCase();
      let capitalizedString = firstCharacter + string.slice(1);
      return capitalizedString;
    },
    open() {
      this.dialog = true;
    },
    async sendInvite() {
      this.sendingInvites = true;
      const invite = httpsCallable(functions, "addInvite");

      const res = await invite({
        invites: this.invites,
        workspace: this.workspace,
        first_name: this.userProfile.first_name,
      });
      console.log(res.data);

      this.$store.dispatch("fetchWorkspace");
      this.$store.commit("setNotification", {
        show: true,
        text: "Invite are sent!",
        type: "primary",
        icon: "",
      });
      this.sendingInvites = false;
      this.sent = true;
      this.dialog = false;
      this.invites = [
        {
          email: "",
          role: "admin",
          invited: true,
          status: null,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 5px;
}
</style>
